
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getCompanySet, getSmsList, modifyCompanySet } from '@/api/system';
import { checkPermissionCompany } from "@/utils/permission";
import { Type } from "@/types/permissionType";


@Component({
  name: 'SystemSettingBase',
  components: {
  }
})
export default class extends Vue {
  private pushCheckShow=false;
  private openPush:any=false;
  private openPushAdmin:any=false;
  // 推送设置
  private formPush: any = {
    number: '',
    pushOrderNew: false,
    pushOrderGrab: false,
    pushDeptAssign: false,
    pushTaskAssign: false,
    pushCustomerOrderUndeal: false,
    pushCustomerTaskUndeal: false,
    pushCustomerTaskUnFinish: false,
    pushCustomerOrderUnevaluated:false,
    pushCustomerOrderCheck:false,
  }
  private formPushRecord: any = {
    // start: '',
    // end: '',
    dateRange: [],
    mobile: '',
    sendStatus: '71',
    ordernumber: ''
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, start]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private optionSendStatus = [{
    value: '71',
    label: '已接通'
  }, {
    value: '0',
    label: '全部'
  }]
  private tableDataPush: any = []
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private getMsgType(val:any) {
    let msg = '';
    switch (parseInt(val.msgtype)) {
      case 30:
        msg = '工单池接单';
        break;
      case 31:
        msg = '新单';
        break;
      case 32:
        msg = '指派部门';
        break;
      case 33:
        msg = '指派任务';
        break;
      case 41:
        msg = '新单超时未处理';
        break;
      case 42:
        msg = '任务超时未处理';
        break;
      case 46:
        msg = '任务超时未完成';
        break;
      case 71:
         msg = '订单评价';
       break;
      case 51:
         msg = '订单审核';
       break;
    }
    return msg;
  }
  created() {
    this.getCompanySet();
    let time = new Date();
    let mounth = time.getMonth() + 1;
    let startString = time.getFullYear() + '/' + mounth + '/01' + ' 00:00:00';
    // this.formPushRecord.start = new Date(startString).getTime();
    // this.formPushRecord.end = time.getTime();
    this.formPushRecord.dateRange = [new Date(startString).getTime(), time.getTime()];
    this.getList();
    this.pushCheckShow = checkPermissionCompany(UserModule.getCompanyId,Type.OrederCheck);
  }
  private search() {
    this.pagination.currentPage = 1;
    this.getList();
  }
  private restSearch() {
    this.formPushRecord = {
      mobile: '',
      sendStatus: '71',
      ordernumber: ''
    };
    let time = new Date();
    let mounth = time.getMonth() + 1;
    let startString = time.getFullYear() + '/' + mounth + '/01' + ' 00:00:00';
    // this.formPushRecord.start = new Date(startString).getTime();
    // this.formPushRecord.end = time.getTime();
    this.formPushRecord.dateRange = [new Date(startString).getTime(), time.getTime()];
    this.pagination.currentPage = 1;
    this.getList();
  }
  private handlePageSizeChange(val: any) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = val;
    this.getList();
  }
  private handleCurrentChange(val: any) {
    this.pagination.currentPage = val;
    this.getList();
  }
  private getList() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.type = 31;
    pamars.mobile = this.formPushRecord.mobile;
    pamars.start_time = this.formPushRecord.dateRange ? this.formPushRecord.dateRange[0].toString().substr(0, 10) : '';
    pamars.end_time = this.formPushRecord.dateRange ? this.formPushRecord.dateRange[1].toString().substr(0, 10) : '';
    pamars.page = this.pagination.currentPage;
    pamars.size = this.pagination.pageSize;
    if (parseInt(this.formPushRecord.sendStatus) !== 0) {
      pamars.state = this.formPushRecord.sendStatus;
    }
    pamars.order_num = this.formPushRecord.ordernumber;
    getSmsList(pamars).then((res:any) => {
      if (res.data) {
        this.tableDataPush = res.data.list;
        this.pagination.total = res.data.count;
      } else {
        this.tableDataPush = [];
      }
    }).catch(err => {
      this.tableDataPush = [];
      let msg = err.msg;
    });
  }
  private getCompanySet() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanySet(params).then(res => {
      if (res.data && res.data.companySet) {
        this.formPush.number = res.data.companySet.sms_voice_number;
        this.openPush = parseInt(res.data.companySet.is_sms_voice_push) === 1;
        this.openPushAdmin = parseInt(res.data.companySet.is_sms_voice_push_admin) === 1;
        this.formPush.pushOrderNew = parseInt(res.data.companySet.is_sms_voice_push_order_new) === 1;
        this.formPush.pushOrderGrab = parseInt(res.data.companySet.is_sms_voice_push_order_grab) === 1;
        this.formPush.pushDeptAssign = parseInt(res.data.companySet.is_sms_voice_push_dept_assign) === 1;
        this.formPush.pushTaskAssign = parseInt(res.data.companySet.is_sms_voice_push_task_assign) === 1;
        this.formPush.pushCustomerOrderUndeal = parseInt(res.data.companySet.is_sms_voice_push_order_untreated) === 1;
        this.formPush.pushCustomerTaskUndeal = parseInt(res.data.companySet.is_sms_voice_push_task_untreated) === 1;
        this.formPush.pushCustomerTaskUnFinish = parseInt(res.data.companySet.is_sms_voice_push_task_unfinish) === 1;
        this.formPush.pushCustomerOrderUnevaluated = parseInt(res.data.companySet.is_sms_voice_push_order_unevaluated) === 1;
        this.formPush.pushCustomerOrderCheck = parseInt(res.data.companySet.is_sms_voice_push_order_check) === 1;
        
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private openPushChange() {
    let params:any = {};
    params.is_sms_voice_push = this.openPush ? '1' : '0';
    params.is_sms_voice_push_admin = this.openPushAdmin ? '1' : '0';
    this.modifyCompanySet(params);
  }
  private backgroundChange(val:any) {
    let params:any = {};
    params.is_sms_voice_push_order_new = this.formPush.pushOrderNew ? '1' : '0';
    params.is_sms_voice_push_order_grab = this.formPush.pushOrderGrab ? '1' : '0';
    params.is_sms_voice_push_dept_assign = this.formPush.pushDeptAssign ? '1' : '0';
    params.is_sms_voice_push_task_assign = this.formPush.pushTaskAssign ? '1' : '0';
    params.is_sms_voice_push_order_untreated = this.formPush.pushCustomerOrderUndeal ? '1' : '0';
    params.is_sms_voice_push_task_untreated = this.formPush.pushCustomerTaskUndeal ? '1' : '0';
    params.is_sms_voice_push_task_unfinish = this.formPush.pushCustomerTaskUnFinish ? '1' : '0';
    params.is_sms_voice_push_order_unevaluated = this.formPush.pushCustomerOrderUnevaluated ? '1' : '0';
    params.is_sms_voice_push_order_check = this.formPush.pushCustomerOrderCheck ? '1' : '0';
    this.modifyCompanySet(params);
  }
  private modifyCompanySet(pamars:any) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      ...pamars
    };
    modifyCompanySet(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.getCompanySet();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 订单详情
  private OrderDetailHandle(val: any) {
    let routeData = this.$router.resolve({
      path: '/OrderServicer/todetail',
      query: {
        order_service_id: val.order_service_id,
        company_id: UserModule.getCompanyId,
      }
    });
    window.open(routeData.href);
  }

  private rechargeHandle() {
    this.$confirm('请联系报修管家010-62111361进行充值', '提示', {
      confirmButtonText: '确定',
      showCancelButton: false,
      type: 'warning'
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
